import { StrategicRecommendation } from 'types'
import { Caption, Images, Knowledge } from 'blaze-ui/icons'
import { IconProps } from 'blaze-ui/icons/Types'

interface Props extends IconProps {
  feature: StrategicRecommendation['feature']
}

const ICONS = {
  topic: Knowledge,
  captions: Caption,
  images: Images,
}

export const FeatureIcon = ({ feature, ...props }: Props) => {
  const Icon = ICONS[feature]

  if (!Icon) return null

  return <Icon {...props} />
}
